export const AlertIcon = ({ color }: { color?: string }) => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M10 6.66675V10.0001'
            stroke={color || '#FF9900'}
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M10 13.3334H10.0083'
            stroke={color || '#FF9900'}
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <circle cx='10' cy='10' r='8.33333' stroke={color || '#FF9900'} strokeWidth='2' />
    </svg>
)
